import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {SubscriptionService} from '@services/subscription/subscription.service';
import {MatDialog} from '@node_modules/@angular/material';
import {User} from '@models/user';
import {Store} from '@node_modules/@ngrx/store';
import * as AuthReducer from '@store/auth/reducers';
import {OwnerSubscription} from '@models/ownerSubscription';
import {SubscriptionScenario} from '@models/subscriptionScenario';
import {ConfirmModalComponent} from '@components/confirm-modal/confirm-modal.component';
import {AuthFacade} from '@facades/auth/authFacade';
import * as ProgramReducer from '@store/program/reducers';
import {PaymentService} from '@services/payment/payment.service';

@Component({
  selector: 'app-recharge-failed-charge-student-dialog',
  templateUrl: './recharge-failed-charge-student-dialog.component.html',
  styleUrls: ['./recharge-failed-charge-student-dialog.component.scss']
})
export class RechargeFailedChargeStudentDialog implements OnInit, AfterViewInit {
  static modalRef;
  static systemSubscriptionStatus;
  systemSubscriptionStatus: any;
  subscribes = [];
  user: User;
  charge: any;
  subscription: OwnerSubscription;
  scenario: SubscriptionScenario;
  confirmDialog;
  resultMessageModal;

  constructor(
    private subscriptionService: SubscriptionService,
    private authStore: Store<AuthReducer.AuthState>,
    public dialog: MatDialog,
    private authFacade: AuthFacade,
    private programStore: Store<ProgramReducer.ProgramState>,
    private paymentService: PaymentService
  ) {
    //
  }

  ngOnInit() {
    this.systemSubscriptionStatus = RechargeFailedChargeStudentDialog.systemSubscriptionStatus;
  }

  ngAfterViewInit() {
    //
  }

  handleSubmit() {
    this.studentRechargeFailedPayment();
  }

  studentRechargeFailedPayment() {
    this.paymentService
      .rechargeExtended({
        mode: 'now',
        id: this.systemSubscriptionStatus.charge.id,
        date: ''
      })
      .subscribe(response => {
        this.handleClose();
        this.showSuccessRechargeMessage();
        this.authFacade.fetchUser();
      }, error => {
        this.handleClose();
        this.showFailedRechargeMessage(error.error.errors);
      });
  }

  showSuccessRechargeMessage() {
    ConfirmModalComponent.textModal = 'Your card was charged';
    ConfirmModalComponent.textButton = 'OK';
    ConfirmModalComponent.withButtons = true;
    ConfirmModalComponent.hideCancel = true;
    ConfirmModalComponent.methodDelete = 'handleCloseResultMessageModal';
    ConfirmModalComponent.insertedObject = this;
    this.resultMessageModal = this.dialog.open(ConfirmModalComponent);
    ConfirmModalComponent.modalRef = this.resultMessageModal;
  }

  showFailedRechargeMessage(message: string = '') {
    ConfirmModalComponent.textModal = message;
    ConfirmModalComponent.textButton = 'OK';
    ConfirmModalComponent.withButtons = true;
    ConfirmModalComponent.hideCancel = true;
    ConfirmModalComponent.methodDelete = 'handleCloseResultMessageModal';
    ConfirmModalComponent.insertedObject = this;
    this.resultMessageModal = this.dialog.open(ConfirmModalComponent);
    ConfirmModalComponent.modalRef = this.resultMessageModal;
  }

  handleCloseResultMessageModal() {
    if (this.resultMessageModal.modalRef) {
      this.resultMessageModal.modalRef.close();
    }
  }

  handleClose() {
    if (RechargeFailedChargeStudentDialog.modalRef) {
      RechargeFailedChargeStudentDialog.modalRef.close();
    }
  }
}
